<div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" (click)="onClose()">
  <div class="relative w-full max-w-5xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-[0_24px_70px_rgba(15,23,42,0.25)] border border-slate-100/60 dark:border-slate-700 overflow-hidden animate-fade-in-up" (click)="$event.stopPropagation()">
    <div class="absolute top-0 left-[10%] w-[80%] h-1.5 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 rounded-b-full"></div>
    <div *ngIf="isLoading() || isSaving()" class="absolute inset-0 z-50 bg-white/70 dark:bg-slate-900/70 backdrop-blur-sm flex items-center justify-center">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="px-6 md:px-8 pt-8 pb-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <span class="w-11 h-11 rounded-2xl bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center">
          <span class="material-icons">sensor_door</span>
        </span>
        <div>
          <h2 class="text-xl font-black text-slate-800 dark:text-slate-100">{{ isEdit ? 'แก้ไขประตู' : 'เพิ่มประตู' }}</h2>
          <p class="text-xs text-slate-400 mt-0.5">ลาน: {{ siteName || '—' }}</p>
        </div>
      </div>
      <button (click)="onClose()" class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-all cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 md:p-8 space-y-6 max-h-[75vh] overflow-y-auto custom-scrollbar">
      <div *ngIf="isEdit" class="flex items-center gap-2 px-4 py-3 rounded-2xl bg-slate-50 dark:bg-slate-800 text-xs text-slate-500">
        <span class="material-icons text-amber-500 text-[18px]">info</span>
        <span>ID: <b class="text-slate-700 dark:text-slate-200">{{ formData.id }}</b></span>
        <span class="mx-1 text-slate-300">•</span>
        <span>สร้างเมื่อ {{ formData.createDate | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>

      <section>
        <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">ข้อมูลหลัก</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">ชื่อประตู <span class="text-rose-500">*</span></label>
            <input [(ngModel)]="formData.name" placeholder="ระบุชื่อประตู"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Display Name</label>
            <input [(ngModel)]="formData.displayName" placeholder="ชื่อแสดงผล"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="md:col-span-2">
            <label class="block text-xs font-bold text-slate-500 mb-2">Detail</label>
            <textarea [(ngModel)]="formData.detail" rows="2" placeholder="รายละเอียด"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">ประเภทประตู</label>
            <select [(ngModel)]="formData.gateTypeId"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200">
              <option [ngValue]="null">-- เลือกประเภทประตู --</option>
              <option *ngFor="let gt of gateTypes" [ngValue]="gt.id">{{ gt.name }} (ID {{ gt.id }})</option>
            </select>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">ประเภทรถ</label>
            <select [(ngModel)]="formData.vehicleTypeId"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200">
              <option [ngValue]="null">-- เลือกประเภทรถ --</option>
              <option *ngFor="let vt of vehicleTypes" [ngValue]="vt.id">{{ vt.name }} (ID {{ vt.id }})</option>
            </select>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">ประตูหลัก (Parent Gate)</label>
            <select [(ngModel)]="formData.parentGateId"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200">
              <option [ngValue]="null">-- ไม่ระบุ --</option>
              <option *ngFor="let g of parentGates" [ngValue]="g.id">{{ g.name }} (ID {{ g.id }})</option>
            </select>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Area ID</label>
            <input type="number" [(ngModel)]="formData.areaId"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
        </div>
      </section>

      <section class="border-t border-slate-100 dark:border-slate-800 pt-5">
        <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">การเชื่อมต่อ / อุปกรณ์</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">IP</label>
            <input [(ngModel)]="formData.ip" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">POS ID</label>
            <input [(ngModel)]="formData.posId" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Device Key</label>
            <input [(ngModel)]="formData.deviceKey" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">API User</label>
            <input [(ngModel)]="formData.apiUser" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">API Pass</label>
            <input type="password" [(ngModel)]="formData.apiPass" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Connect Date</label>
            <input type="datetime-local" [ngModel]="connectDateLocal" (ngModelChange)="onConnectDateChange($event)"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Monitor</label>
            <input [(ngModel)]="formData.monitor" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Status ID</label>
            <input [(ngModel)]="formData.statusId" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Prefix</label>
            <input [(ngModel)]="formData.prefix" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
        </div>
      </section>

      <section class="border-t border-slate-100 dark:border-slate-800 pt-5">
        <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">ค่าธรรมเนียม / EV / อื่นๆ</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Default Rate ID</label>
            <input type="number" [(ngModel)]="formData.defaultRate" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">EV Connector Type ID</label>
            <input type="number" [(ngModel)]="formData.evConnectorTypeId" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Power kW</label>
            <input type="number" step="0.01" [(ngModel)]="formData.powerKw" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Company ID</label>
            <input type="number" [(ngModel)]="formData.companyId" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">SAP Name</label>
            <input [(ngModel)]="formData.sapName" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">SAP Name M</label>
            <input [(ngModel)]="formData.sapNameM" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Check Code</label>
            <input [(ngModel)]="formData.checkCode" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="md:col-span-2">
            <label class="block text-xs font-bold text-slate-500 mb-2">Display Names</label>
            <input [(ngModel)]="formData.displayNames" class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mt-4">
          <label class="flex items-center justify-between gap-4 p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 cursor-pointer">
            <div>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">Customer Visible</p>
              <p class="text-xs text-slate-400">แสดงให้ลูกค้าเห็น</p>
            </div>
            <input type="checkbox" [(ngModel)]="formData.customerVisible" class="w-5 h-5 rounded text-amber-500 focus:ring-amber-300" />
          </label>
          <label class="flex items-center justify-between gap-4 p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 cursor-pointer">
            <div>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">Staff Visible</p>
              <p class="text-xs text-slate-400">แสดงให้เจ้าหน้าที่เห็น</p>
            </div>
            <input type="checkbox" [(ngModel)]="formData.staffVisible" class="w-5 h-5 rounded text-amber-500 focus:ring-amber-300" />
          </label>
          <label class="flex items-center justify-between gap-4 p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 cursor-pointer">
            <div>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">Taiwan Gate</p>
              <p class="text-xs text-slate-400">ประตูระบบ Taiwan</p>
            </div>
            <input type="checkbox" [(ngModel)]="formData.taiwanGate" class="w-5 h-5 rounded text-amber-500 focus:ring-amber-300" />
          </label>
          <label class="flex items-center justify-between gap-4 p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 cursor-pointer">
            <div>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">Online</p>
              <p class="text-xs text-slate-400">สถานะเชื่อมต่อประตู/อุปกรณ์</p>
            </div>
            <input type="checkbox" [(ngModel)]="formData.online" class="w-5 h-5 rounded text-amber-500 focus:ring-amber-300" />
          </label>
        </div>
      </section>

      <div *ngIf="isEdit" class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-800/40 p-4">
        <div class="font-bold text-[10px] text-slate-400 uppercase tracking-widest mb-3">ข้อมูลตรวจสอบ Odoo</div>
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 text-xs text-slate-500">
          <div>create_uid: <b>{{ formData.createUid ?? '—' }}</b></div>
          <div>write_uid: <b>{{ formData.writeUid ?? '—' }}</b></div>
          <div>create_date: <b>{{ formData.createDate | date:'dd/MM/yyyy HH:mm' }}</b></div>
          <div>write_date: <b>{{ formData.writeDate | date:'dd/MM/yyyy HH:mm' }}</b></div>
          <div>attachment_id: <b>{{ formData.messageMainAttachmentId ?? '—' }}</b></div>
          <div>update_by: <b>{{ formData.updateBy || '—' }}</b></div>
          <div>site: <b>{{ formData.siteName || formData.siteId || '—' }}</b></div>
          <div>area: <b>{{ formData.areaName || formData.areaId || '—' }}</b></div>
          <div>rate: <b>{{ formData.defaultRateName || formData.defaultRate || '—' }}</b></div>
        </div>
      </div>
    </div>

    <div class="px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col-reverse sm:flex-row justify-between gap-3 bg-slate-50/50 dark:bg-slate-900/50">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col-reverse sm:flex-row justify-end gap-3 ml-auto w-full sm:w-auto">
        <button (click)="onClose()" class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:bg-white dark:hover:bg-slate-800 transition-all cursor-pointer">ยกเลิก</button>
        <button (click)="onSave()" [disabled]="isSaving()"
          class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-none disabled:opacity-50 transition-all cursor-pointer flex items-center justify-center gap-2">
          <span class="material-icons text-[18px]">save</span>{{ isSaving() ? 'กำลังบันทึก...' : 'บันทึกข้อมูล' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingGate"
  [entityId]="itemId"
  title="ประวัติประตู"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
